import React, { useEffect } from "react";
import { useSelector } from "react-redux";

import { isNonEmptyString } from "@cayuse/shared-react.utils.type-checks";
import SubHeader from "@cayuse/shared-react.components.sub-header";

import { refreshReviewEvents } from "store/actions/proposal";
import { useDictionary } from "hooks";
import RoutingTable from "components/RoutingTable";
import { proposalSelectors } from "store/selectors";

import styles from "./styles.css";


const Routing = () => {
	const {
		isFetching,
		error,
		proposalId,
		formRules,
		reviewEvents,
		certificationEvents,
		round,
	} = useSelector(proposalSelectors.proposal);

	const dictionary = useDictionary("proposals.routing");

	useEffect(() => {
		if (isNonEmptyString(proposalId)) {
			refreshReviewEvents(proposalId);
		}
	}, [ proposalId ]);

	return (
		<div data-component="Routing">
			<SubHeader className={styles.heading}>{dictionary.sectionHeading || "Routing for Review"}</SubHeader>
			<RoutingTable
				formRules={formRules}
				reviewEntries={reviewEvents}
				certificationEntries={certificationEvents}
				currentRound={round}
				isLoading={isFetching}
				hasError={isNonEmptyString(error)} 
				dictionary={dictionary}  />
		</div>
	);
};

export default Routing;
